<div  (mousedown)="mouseDown($event)" (mouseup)="mouseUp($event)">
  <div class="resize-action"></div>
  <div class="modal-screen-overlay" >
    <div class="Modal" [style.transform]="'translate3d(' + left + 'px,' + top + 'px,' + '0px)'" style="transition: transform 0s">
      @if (alertService.currentAlert) {
        <alert-app></alert-app>
      }
      @if (alert) {
        <div>
          {{ alert.title }} - {{ alert.Message }}
        </div>
      }
      @if (alertService.currentDialog) {
        <app-standard-dialog></app-standard-dialog>
      }
      @if (DataService.SelectedMatch) {
        <app-score-edit></app-score-edit>
      }
      @if (alertService.showChangeCalendarTextDialog == true) {
        <div id="ChangeCalendarTextDialog" style="top: 200px;left: 130px">
          <div class="window-bar" id="change-calendar-window-bar">
            <label>Edit Calendar Text</label>
            <button type="button" id="btnClose" name="btnClose" (click)="alertService.showChangeCalendarTextDialog = false;">X</button>
          </div>
          <div id="customDialogChangeCalendarText" class="enterTorn">
            <div><textarea style="height: 200px;width: 400px" id="txtCalendarText" [(ngModel)]="DataService.Settings[0].value"></textarea></div>
            <button type="button" id="btnChangeCalendarText" (click)="UpdateCalendarText()" class="enterTorn">OK</button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
